// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoPlayer_videoContainer__Nr0T6","videoTitle":"VideoPlayer_videoTitle__bW3+A","videoWrapper":"VideoPlayer_videoWrapper__refSw","video":"VideoPlayer_video__kUj8+"};